export enum DockDoorScanV2Modal {
  INVALID_BARCODE = "INVALID_BARCODE",
  GAYLORD_NOT_FOUND = "GAYLORD_NOT_FOUND",
  MISSING_GAYLORD_SORT_CODE = "MISSING_GAYLORD_SORT_CODE",
  GAYLORD_DOCK_DOOR_MISMATCH = "GAYLORD_DOCK_DOOR_MISMATCH",
  DOCK_DOOR_MAPPING_NOT_FOUND = "DOCK_DOOR_MAPPING_NOT_FOUND",
  DOCK_DOOR_DOES_NOT_EXIST = "DOCK_DOOR_DOES_NOT_EXIST",
  GAYLORD_TRANSFER_NOT_COMPLETE = "GAYLORD_TRANSFER_NOT_COMPLETE",
  QUINCE_GAYLORD_NOT_STAGED = "QUINCE_GAYLORD_NOT_STAGED",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
}
